import {
  $jingleCollectionsTableSearchInputValue,
  jingleCollectionsTableSearchChanged,
} from '@/entities/jingle-collections'
import {
  $jinglesTableSearchInputValue,
  JinglesTableFiltersMenu,
  jinglesTableSearchChanged,
} from '@/entities/tracks'
import { ROUTES, STRINGS } from '@/shared/config'
import { useHashTabs } from '@/shared/lib/react-hooks'
import { BorderlessTabs, HeaderContent } from '@/shared/ui'
import { ContentWrapper } from '@/shared/ui'
import { JingleForm } from '@/widgets/JingleForm'
import { jingleFormModalOpened } from '@/widgets/JingleForm'
import { FilterOutlined, PlusOutlined, SearchOutlined } from '@ant-design/icons'
import { Button, Input, Layout, Popover, Space } from 'antd'
import { useUnit } from 'effector-react'
import { useNavigate } from 'react-router-dom'

import {
  type JinglesListPageTabsKeys,
  JinglesListPageTabsKeysArray,
  JinglesListPageTabsKeysEnum,
} from './lib/tabs'
import {
  $jinglesListPageTab,
  JinglesListPageGate,
  jinglesListPageTabChanged,
} from './model/jingles-list.model'
import { JingleCollectionsTab, JinglesTab } from './ui/tabs'

export function JinglesListPage() {
  const navigate = useNavigate()
  const jinglesSearch = useUnit($jinglesTableSearchInputValue)
  const changeJinglesSearch = useUnit(jinglesTableSearchChanged)

  const jingleCollectionsSearch = useUnit(
    $jingleCollectionsTableSearchInputValue,
  )
  const changeJingleCollectionsSearch = useUnit(
    jingleCollectionsTableSearchChanged,
  )

  const openJingleFormModal = useUnit(jingleFormModalOpened)

  const { tab, handleTabChange } = useHashTabs<JinglesListPageTabsKeys>(
    JinglesListPageTabsKeysArray,
    $jinglesListPageTab,
    jinglesListPageTabChanged,
  )

  const handleCreate = () => {
    if (tab === 'jingle') {
      openJingleFormModal()
    } else {
      void navigate(ROUTES.JINGLES.CREATE_COLLECTION)
    }
  }

  return (
    <Layout>
      <JinglesListPageGate />
      <JingleForm isModal />
      <HeaderContent
        title="Джинглы"
        description="Раздел позволяет создавать джинглы и настраивать их воспроизведение"
      />
      <ContentWrapper verticalPadding="small">
        <BorderlessTabs
          activeKey={tab}
          onChange={handleTabChange}
          destroyOnHidden
          tabBarExtraContent={
            <Space>
              <Popover
                content={<JinglesTableFiltersMenu />}
                title={STRINGS.label_filters_control}
                trigger="click"
                placement="bottom"
                destroyOnHidden
              >
                <Button
                  disabled={tab === 'jinglecollection'}
                  icon={<FilterOutlined />}
                >
                  {STRINGS.label_filters_control}
                </Button>
              </Popover>

              <Input
                placeholder={STRINGS.placeholder_search_by_name_input}
                allowClear
                addonAfter={<SearchOutlined />}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  const searchString = event.target.value
                  if (tab === 'jingle') changeJinglesSearch(searchString)
                  else changeJingleCollectionsSearch(searchString)
                }}
                style={{
                  minWidth: 300,
                }}
                value={
                  (tab === 'jingle'
                    ? jinglesSearch
                    : jingleCollectionsSearch) || ''
                }
              />
              <Button
                variant="solid"
                icon={<PlusOutlined />}
                onClick={handleCreate}
              >
                {`Создать ${tab === 'jingle' ? 'джингл' : 'подборку'} `}
              </Button>
            </Space>
          }
          items={[
            {
              label: 'Все джинглы',
              key: JinglesListPageTabsKeysEnum.jingle,
              children: <JinglesTab />,
            },
            {
              label: 'Подборки',
              key: JinglesListPageTabsKeysEnum.jinglecollection,
              children: <JingleCollectionsTab />,
            },
          ]}
        />
      </ContentWrapper>
    </Layout>
  )
}
